import { render, staticRenderFns } from "./SettingTableV1.vue?vue&type=template&id=01c7734a&scoped=true&"
import script from "./SettingTableV1.vue?vue&type=script&lang=js&"
export * from "./SettingTableV1.vue?vue&type=script&lang=js&"
import style0 from "./SettingTableV1.vue?vue&type=style&index=0&id=01c7734a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7734a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VSimpleTable,VSwitch,VTab,VTabs,VTextField})
